module.exports = __webpack_public_path__ + "static/media/creature-desk.efc41c49.svg";